var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 153,
    viewBox: "0 0 249 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.636 59.1061C221.006 54.4108 212.705 50.3598 212.705 42.9018C212.705 37.4012 216.446 34.6386 219.689 33.8209V32.6812C204.093 34.143 193.369 43.3726 193.369 56.17C193.369 69.7852 203.124 76.091 212.544 81.6039C221.155 86.4727 228.636 90.6848 228.636 97.4862C228.636 103.643 225.219 106.728 220.348 107.694V108.661C237.907 107.521 248.793 98.7746 248.793 83.0658C248.793 72.3744 239.373 65.573 228.649 59.0814",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.692 81.1333H192.561L193.369 104.3C197.756 106.245 208.157 108.686 215.464 108.686V107.719C208.318 105.44 196.612 91.676 193.692 81.1457",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.909 57.0003H245.04L244.232 35.2954C241.635 34.3291 232.041 32.5327 224.25 32.5327V33.6725C232.215 35.1343 240.989 46.7921 243.909 57.0003Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.704 0C183.403 0 188.622 5.04218 188.622 14.9779C188.622 26.1772 176.443 37.2031 163.321 40.833L162.848 39.7304C170.267 36.1005 176.133 31.6902 177.873 22.5474C176.767 22.8571 175.337 23.1668 173.598 23.1668C166.8 23.1668 162.053 18.6078 162.053 11.8188C162.053 5.02979 167.583 0 174.704 0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5089 45.5033C74.7911 45.5033 81.0915 39.2223 81.0915 31.9625C81.0915 24.7027 74.7911 18.4341 67.5089 18.4341C60.2267 18.4341 53.9263 24.5169 53.9263 31.9625C53.9263 39.4081 60.0279 45.5033 67.5089 45.5033Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6667 86.1136C45.2646 86.1136 31.8808 78.2592 31.8808 52.1687C31.8808 28.6178 45.0658 19.7847 52.932 18.2238V16.6504C26.9722 18.422 0.987488 37.4509 0.987488 65.7095C0.987488 88.2692 14.7689 108.673 41.9218 108.673C69.0746 108.673 79.7121 88.8515 82.4709 76.884L81.2903 76.1035C77.3634 81.7899 68.3042 86.1136 57.6791 86.1136",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8788 122.598C69.3978 122.598 63.2962 128.681 63.2962 136.139C63.2962 143.597 69.3978 149.667 76.8788 149.667C84.3598 149.667 90.2626 143.597 90.2626 136.139C90.2626 128.681 84.1734 122.598 76.8788 122.598Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.018 18.5832V19.5619L103.758 21.9158C107.3 24.4554 109.077 27.2057 109.077 34.0814V99.4439C108.692 123.379 108.095 132.992 97.4702 144.96C95.3079 147.115 91.3686 150.064 88.6098 151.625L89.0075 153C95.5067 151.043 103.174 147.908 108.294 145.158C124.039 136.325 139.97 124.952 139.97 95.3185V34.6637C139.97 26.8217 140.368 15.6347 140.567 7.59447L139.97 7.01221L100.018 18.5832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.83042b54689c8d576dc67ca279a1538c.svg";
export { ForwardRef as ReactComponent };